module.exports = __webpack_public_path__ + "img/web-16.cfebdb73.gif";